import LocomotiveScroll from 'locomotive-scroll';
window.locoScroll = new LocomotiveScroll({
    el: document.querySelector('[data-scroll-container]'),
    smooth: true
});